import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { RootState, RestaurantState, Restaurant } from '@/definitions'
import { AxiosResponse } from 'axios'
import Swal from 'sweetalert2'
import axios from '@/plugins/axios'
import dayjs from 'dayjs'

const state: RestaurantState = {
  restaurants: []
}

const getters: GetterTree<RestaurantState, unknown> = {
  restaurants: (state): Restaurant[] => state.restaurants
}

const mutations: MutationTree<RestaurantState> = {
  setRestaurants (state, restaurants: Restaurant[]): void {
    state.restaurants = restaurants
  }
}

const actions: ActionTree<RestaurantState, RootState> = {
  async fetchRestaurants ({ commit }): Promise<void> {
    try {
      const res: AxiosResponse = await axios.get('/restaurants')

      const restaurants: Restaurant[] = res.data.map((item: any) => {
        return {
          id: item.id,
          name: item.name,
          address: item.address,
          latitude: item.latitude,
          longitude: item.longitude,
          coverImage: item.cover_image,
          isActive: item.is_active,
          createdAt: dayjs(item.created_at),
          items: []
        }
      })
      commit('setRestaurants', restaurants)
    } catch (error) {
      if (error.response) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.message
        })
      } else if (error.request) {
        console.log(error.request)
      } else {
        console.log('Error', error.message)
      }
    }
  }
}

export const restaurant: Module<RestaurantState, RootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
